import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/core';
import { theme } from '../../styles';

// Keyframe animations for pin fade effects
export const fadeInPin = keyframes`
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const fadeOutPin = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.5);
  }
`;

// Pulse animation for pins to indicate clickability
export const pulseAnimation = css`
  animation: pulse 1.5s infinite ease-in-out;
  
  @keyframes pulse {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.25); opacity: 0.8; }
    100% { transform: scale(1); opacity: 1; }
  }
`;

export const PinContainer = styled.g`
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const PinShape = styled.path`
  fill: ${theme.colors.primaryred};
  transition: fill 0.2s ease;
`;

export const PinCount = styled.text`
  font-family: ${theme.fontFamily.primary};
  font-size: 10px;
  font-weight: 700;
  text-anchor: middle;
  dominant-baseline: central;
  pointer-events: none;
  fill: black;
  stroke: none;
`;

export const CountryLabel = styled.text`
  fill: ${theme.colors.black};
  font-family: ${theme.fontFamily.primary};
  font-size: 12px;
  font-weight: 600;
  text-anchor: middle;
  pointer-events: none;
  z-index: 100;
  stroke: white;
  stroke-width: 0.25px;
`;

export const InfoBoxContainer = styled.div`
  position: absolute;
  background: white;
  border: 2px solid ${theme.colors.primaryred};
  min-width: 280px;
  max-width: 320px;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  @media (max-width: ${theme.breakpoints.s}) {
    min-width: 250px;
    max-width: 280px;
  }
`;

export const InfoBoxHeaderWrapper = styled.div`
  display: flex;
  gap: 24px;
  align-content: center;
  justify-content: space-between;
  border-bottom: 1px solid ${theme.colors.primaryred};
`;

export const InfoBoxHeader = styled.div`
  padding: 12px 15px;
  color: ${theme.colors.primaryred};
  font-family: ${theme.fontFamily.primary};
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const InfoBoxLink = styled.div`
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
`;

export const InfoBoxContent = styled.div`
  padding: 15px;
`;

export const InfoBoxTitle = styled.h3`
  font-family: ${theme.fontFamily.primary};
  font-size: 18px;
  font-weight: 700;
  color: ${theme.colors.primaryred};
  margin: 0 0 10px 0;
  line-height: 1.3;
`;

export const InfoBoxExcerpt = styled.p`
  font-family: ${theme.fontFamily.primary};
  font-size: 14px;
  color: ${theme.colors.black};
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const InfoBoxFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  border-top: 2px solid ${theme.colors.primaryred};
`;

export const InfoBoxNavButton = styled.button`
  background: none;
  border: 1px solid transparent;
  cursor: pointer;
  padding: 5px;
  color: ${theme.colors.primaryred};
  transition: opacity 0.2s ease;

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    opacity: 0.7;
    border: 1px solid ${theme.colors.primaryred};
  }

  &:focus {
    outline: none;
    outline-color: transparent;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const InfoBoxPagination = styled.span`
  font-family: ${theme.fontFamily.primary};
  font-size: 14px;
  color: ${theme.colors.primaryred};
`;

export const InfoBoxClose = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  color: ${theme.colors.primaryred};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const MapContainer = styled.div`
  position: relative;
`;

export const MapScrollContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  
  /* Hide scrollbar */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;
